import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import {ApiProvider} from "../api/api";
import {URLSearchParams} from "@angular/http";
import {SettingsProvider} from "../settings";
import {LoaderProvider} from "../loader";

@Injectable()
export class EmailService {
    constructor(
        public alertCtrl: AlertController,
        public api: ApiProvider,
        public set: SettingsProvider,
        public loader: LoaderProvider) { }

    showPrompt(fatura?: any) {
        console.log(fatura);
        let email = "";
        if(fatura.email != undefined && fatura.email != "") {
            email = fatura.email;
        }
        let Prompt = this.alertCtrl.create({
            title: 'Enviar Fatura por E-mail',
            inputs: [
                {
                    name: 'email',
                    placeholder: 'Informe um E-Mail',
                    type: 'email',
                    value: email
                },
            ],
            buttons: [
                {
                    text: 'Fechar',
                    handler: data => {
                    }
                },
                {
                    text: 'Enviar',
                    handler: data => {
                        if(data.email != undefined && data.email != "") {
                            // o e-mail foi alterado, pergunta se deseja atualizar
                            if(email != data.email) {
                                let confirm = this.alertCtrl.create({
                                    title: 'Atualizar?',
                                    message: 'Deseja atualizar o e-mail do sócio?',
                                    buttons: [
                                        {
                                            text: 'Não',
                                            handler: () => {
                                                this.PostFormEmail(fatura, data, false);
                                            }
                                        },
                                        {
                                            text: 'Sim',
                                            handler: () => {
                                                this.PostFormEmail(fatura, data, true);
                                            }
                                        }
                                    ]
                                });
                                confirm.present();
                            } else {
                                this.PostFormEmail(fatura, data, false);
                            }
                        } else {
                            alert("Informe um E-mail válido.");
                            return false;
                        }
                    }
                }
            ]
        });
        Prompt.present();
    }

    PostFormEmail(fatura, data, updateEmail) {
        this.loader.show();
        let urlSearchParams = new URLSearchParams();
        urlSearchParams.append('fat_id', fatura.id);
        urlSearchParams.append('fat_email', fatura.email);
        urlSearchParams.append('usuario_id', fatura.usuario_id);
        urlSearchParams.append('form_email', data.email);
        urlSearchParams.append('update_email', updateEmail);

        this.api.post("fatEmail.php", urlSearchParams).then((data:any) => {
            console.log(data);
            this.set.showToast(data.message);
            this.loader.hide();
        }).catch(err => {
            let erros = "";
            for(let o in err){
                erros = err[o][0];
            }
            this.set.showToastWithCloseButton(erros);
            this.loader.hide();
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/util/email.service.ts